import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter as Router } from 'connected-react-router';
import { history } from '../redux'
import { ToastContainer } from 'react-toastify';


import { userIsAuthenticated, userIsNotAuthenticated } from '../hoc/authentication';

import { path } from '../utils'

import Home from '../routes/Home';
import Login from './Auth/Login';
// import Header from './Header/Header';
// import Menu from './Menu/Menu';
import System from '../routes/System';

import { CustomToastCloseButton } from '../components/CustomToast';
import ConfirmModal from '../components/ConfirmModal';
import Register from './Auth/Register';
import { gapi } from 'gapi-script';

class App extends Component {

    useEffect = () => {
        function start() {
            gapi.client.init({
                clientId: "510041985758-c8u658vpleekkntkbm1t1vsphim3k37o.apps.googleusercontent.com",
                scope: ""
            })
        }
    }
    handlePersistorState = () => {
        const { persistor } = this.props;
        let { bootstrapped } = persistor.getState();
        if (bootstrapped) {
            if (this.props.onBeforeLift) {
                Promise.resolve(this.props.onBeforeLift())
                    .then(() => this.setState({ bootstrapped: true }))
                    .catch(() => this.setState({ bootstrapped: true }));
            } else {
                this.setState({ bootstrapped: true });
            }
        }
    };

    componentDidMount() {
        this.handlePersistorState();
    }

    render() {
        return (
            <Fragment>
                <Router history={history}>
                    <div id="layout-wrapper">
                        <ConfirmModal />
                        {/* {this.props.isLoggedIn && <Header />} */}
                        <Switch>
                            <Route path={path.HOME} exact component={(Home)} />
                            <Route path={path.HOMEDEFAULT} exact component={(Home)} />
                            <Route path={path.LOGIN} component={userIsNotAuthenticated(Login)} />
                            <Route path={path.REGISTER} component={userIsNotAuthenticated(Register)} />
                            <Route path={path.SYSTEM} component={(System)} />
                            {/* <Route path={path.SYSTEM} component={userIsAuthenticated(System)} /> */}
                        </Switch>
                        <ToastContainer
                            className="toast-container" toastClassName="toast-item" bodyClassName="toast-item-body"
                            autoClose={false} hideProgressBar={true} pauseOnHover={false}
                            pauseOnFocusLoss={true} closeOnClick={false} draggable={false}
                            closeButton={<CustomToastCloseButton />}
                        />
                    </div>
                </Router>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        started: state.app.started,
        isLoggedIn: state.user.isLoggedIn
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);